import type { IFilterData } from '@rankmi/rankmi-table/dist/interfaces/filterProps'

import { Segment } from 'models/segment.model'
import { applyFilters } from 'helpers/filterData.helper'
import { SortValue } from 'models/rankmiTable.model'
import { sortTableEnum } from 'enum/sortTable.enum'
import api from '../..'

export interface ListSegmentsParams {
  page: number
  perPage: number
  filterData?: IFilterData
  searchText?: string
  sort?: SortValue
}

export const listSegments = ({
  page,
  perPage,
  filterData,
  searchText,
  sort,
}: ListSegmentsParams) => {
  const q = {}
  const { field, order } = { ...sort }
  if (searchText) q['name_cont'] = searchText
  if (field && order) q['s'] = [`${field} ${sortTableEnum[order]}`]
  q['g'] = applyFilters(filterData)
  return api
    .post(`administration/segments/search`, {
      q,
      page,
      perPage,
    })
    .then(({ data: { data }, headers }) => ({
      data: data.map(({ attributes }) => attributes) as Segment[],
      total: parseInt(headers['total']),
      perPage: parseInt(headers['per-page']),
    }))
}
